module.exports = __webpack_public_path__ + "img/pr-4.eb4b020c.png";